import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
var render = function render() {
  var _setup$recipeListingC, _setup$recipeListingC2, _setup$recipeListingC3, _setup$recipeListingF, _setup$recipeListingF2, _setup$recipeListingF3, _setup$recipeListing, _setup$recipeListingF4, _setup$recipeListingP, _setup$recipeListingP2, _setup$recipeListingP3, _setup$route$query, _setup$recipeListingC6, _setup$recipeListingC7;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c(_setup.AppCategoriesHeader, {
    attrs: {
      "type": "rlp",
      "breadcrumbs": _setup.breadcrumbs,
      "title": (_setup$recipeListingC = _setup.recipeListingContent) === null || _setup$recipeListingC === void 0 ? void 0 : _setup$recipeListingC.title,
      "description": (_setup$recipeListingC2 = _setup.recipeListingContent) === null || _setup$recipeListingC2 === void 0 ? void 0 : (_setup$recipeListingC3 = _setup$recipeListingC2.description) === null || _setup$recipeListingC3 === void 0 ? void 0 : _setup$recipeListingC3.json
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listing"
  }, [!_setup.isStatic && (!_setup.loading || (_setup$recipeListingF = _setup.recipeListingFacets) !== null && _setup$recipeListingF !== void 0 && _setup$recipeListingF.length) ? _c('div', {
    staticClass: "filters"
  }, [(_setup$recipeListingF2 = _setup.recipeListingFacets) !== null && _setup$recipeListingF2 !== void 0 && _setup$recipeListingF2.length ? [_c('ClientOnly', [_c(_setup.AzSidebar, {
    ref: "sidebar",
    staticClass: "mobile-only",
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v(_vm._s(_vm.$t('filters.title')))];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c(_setup.SearchFiltersOrganism, {
          attrs: {
            "available-facets": _setup.recipeListingFacets,
            "sorting": _setup.recipeListingSort
          },
          on: {
            "sort": _setup.closeSidebar
          }
        })];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function fn() {
        return [_c(_setup.AzButton, {
          staticClass: "sidebar-footer__button",
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": _setup.onClearFilters
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$t('filters.clear')) + "\n              ")]), _vm._v(" "), _c(_setup.AzButton, {
          staticClass: "sidebar-footer__button"
        }, [_vm._v("\n                " + _vm._s(_setup.i18n.tc('filters.apply', _setup.recipeListingPagination.count)) + "\n              ")])];
      },
      proxy: true
    }], null, false, 2928071118)
  })], 1), _vm._v(" "), _c(_setup.SearchFiltersOrganism, {
    staticClass: "desktop-only",
    attrs: {
      "available-facets": _setup.recipeListingFacets
    },
    on: {
      "sort": _setup.closeSidebar
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "results"
  }, [_c('ClientOnly', [_setup.isMobile && !_setup.isStatic ? _c(_setup.MobileFiltersButton, {
    staticClass: "mobile-filters-button",
    on: {
      "click": _setup.openSidebar
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar"
  }, [_c(_setup.CategoryPageHeader, {
    attrs: {
      "total-items": _setup.itemCount,
      "pagination": _setup.recipeListingPagination,
      "sorting": _setup.recipeListingSort
    },
    on: {
      "change-sort": function changeSort($event) {
        return _setup.changeSort($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_vm._v(_vm._s(_vm.$tc('search.recipesCount', _setup.itemCount, {
          count: _setup.itemCount
        })))];
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _setup.loading || _setup.isWaiting('sort.change') ? _c('div', {
    staticClass: "recipes",
    class: {
      'recipes-wide': !((_setup$recipeListingF3 = _setup.recipeListingFacets) !== null && _setup$recipeListingF3 !== void 0 && _setup$recipeListingF3.length)
    }
  }, _vm._l(12, function (count) {
    return _c(_setup.CardSkeleton, {
      key: count,
      attrs: {
        "width": "100%"
      }
    });
  }), 1) : (_setup$recipeListing = _setup.recipeListing) !== null && _setup$recipeListing !== void 0 && _setup$recipeListing.length ? _c('div', {
    staticClass: "recipes",
    class: {
      'recipes-wide': !((_setup$recipeListingF4 = _setup.recipeListingFacets) !== null && _setup$recipeListingF4 !== void 0 && _setup$recipeListingF4.length)
    }
  }, _vm._l(_setup.recipeListing, function (recipe, index) {
    var _setup$recipeListingC4, _setup$recipeListingC5;
    return _c(_setup.AzRecipeCard, {
      key: recipe.url,
      attrs: {
        "title": recipe.title,
        "slug": recipe.url,
        "cover": recipe.photo,
        "category": recipe.category,
        "rating": recipe.rating,
        "num-reviews": recipe.numReviews,
        "type": (_setup$recipeListingC4 = _setup.recipeListingContent) === null || _setup$recipeListingC4 === void 0 ? void 0 : (_setup$recipeListingC5 = _setup$recipeListingC4.recipeTypeV2) === null || _setup$recipeListingC5 === void 0 ? void 0 : _setup$recipeListingC5.id,
        "wishlisted": _setup.isInRecipesWishlists(recipe.recipeId),
        "image-loading": index < 4 ? 'eager' : 'lazy'
      },
      on: {
        "click:wishlist": function clickWishlist($event) {
          return _setup.updateRecipeWishlist(recipe);
        }
      }
    });
  }), 1) : _c('div', {
    staticClass: "empty"
  }, [_c(_setup.AzIcon, {
    staticClass: "empty__icon",
    attrs: {
      "icon-name": "search",
      "size": "largest"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "empty__text empty__text_title"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('empty.title')) + "\n        ")]), _vm._v(" "), _c(_setup.AzRichText, {
    staticClass: "empty__text",
    attrs: {
      "content": _vm.$t('empty.content')
    }
  }), _vm._v(" "), _c(_setup.AzButton, {
    staticClass: "smartphone-only",
    attrs: {
      "color": "tertiary"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('empty.button')) + "\n        ")])], 1), _vm._v(" "), ((_setup$recipeListingP = _setup.recipeListingPagination) === null || _setup$recipeListingP === void 0 ? void 0 : _setup$recipeListingP.pages) > 1 ? _c(_setup.AzPagination, {
    staticClass: "pagination",
    attrs: {
      "current": (_setup$recipeListingP2 = _setup.recipeListingPagination) === null || _setup$recipeListingP2 === void 0 ? void 0 : _setup$recipeListingP2.current,
      "number-of-pages": (_setup$recipeListingP3 = _setup.recipeListingPagination) === null || _setup$recipeListingP3 === void 0 ? void 0 : _setup$recipeListingP3.pages,
      "add-seo-links": true,
      "param-names-to-keep": _setup.filteredParamNames,
      "sort": _setup.selectedSort
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c(Number((_setup$route$query = _setup.route.query) === null || _setup$route$query === void 0 ? void 0 : _setup$route$query.page) > 1 ? 'ClientOnly' : 'div', {
    tag: "component"
  }, [(_setup$recipeListingC6 = _setup.recipeListingContent) !== null && _setup$recipeListingC6 !== void 0 && _setup$recipeListingC6.categoryTags ? _c(_setup.BlockCategoryTagsGraphql, {
    attrs: {
      "category": (_setup$recipeListingC7 = _setup.recipeListingContent) === null || _setup$recipeListingC7 === void 0 ? void 0 : _setup$recipeListingC7.categoryTags
    }
  }) : _vm._e()], 1), _vm._v(" "), _c(_setup.AzBackToTopButton)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };